package com.dotdrives.core

import kotlin.random.Random
import kotlin.time.Clock

private const val UUID_SIZE = 16
private const val TIMESTAMP_BYTES = 6
private const val HEX_DIGITS = "0123456789abcdef"

fun uuidV7(): String {
    val bytes = Random.nextBytes(UUID_SIZE)
    val timestamp = Clock.System.now().toEpochMilliseconds()

    for (index in 0 until TIMESTAMP_BYTES) {
        val shift = (TIMESTAMP_BYTES - index - 1) * 8
        bytes[index] = (timestamp shr shift).toByte()
    }

    bytes[6] = ((bytes[6].toInt() and 0x0f) or 0x70).toByte()
    bytes[8] = ((bytes[8].toInt() and 0x3f) or 0x80).toByte()

    return buildString(36) {
        bytes.forEachIndexed { index, byte ->
            if (index == 4 || index == 6 || index == 8 || index == 10) {
                append('-')
            }
            val value = byte.toInt() and 0xff
            append(HEX_DIGITS[value ushr 4])
            append(HEX_DIGITS[value and 0x0f])
        }
    }
}
